import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft, UserPlus, MapPin } from "lucide-react";
import InviteParent from "./InviteParent";
import Radar from "./Radar";

export function InviteParentScreen({ onBack }) {
  return (
    <div className="px-6 pt-4 pb-4" data-testid="invite-parent-screen">
      <div className="flex items-center justify-between">
        <button onClick={onBack} data-testid="invite-back"
          className="h-10 w-10 rounded-full bg-white border border-sand-200 flex items-center justify-center">
          <ChevronLeft size={18}/>
        </button>
        <p className="text-[11px] tracking-[0.18em] uppercase text-ink-500">Family Care</p>
        <div className="w-10"/>
      </div>
      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
        <div className="flex items-center gap-3 mt-4">
          <div className="h-10 w-10 rounded-2xl bg-terracotta-500 text-white flex items-center justify-center">
            <UserPlus size={18}/>
          </div>
          <div>
            <h1 className="font-display text-[28px] leading-none text-ink-900 tracking-tight">Invite a loved one</h1>
            <p className="text-[12px] text-ink-500 mt-1">Set them up in 60 seconds.</p>
          </div>
        </div>
        <div className="mt-5">
          <InviteParent onDone={onBack}/>
        </div>
      </motion.div>
    </div>
  );
}

export function RadarScreen({ onBack }) {
  return (
    <div data-testid="radar-screen-wrap">
      <div className="px-6 pt-4 flex items-center justify-between">
        <button onClick={onBack} data-testid="radar-back"
          className="h-10 w-10 rounded-full bg-white border border-sand-200 flex items-center justify-center">
          <ChevronLeft size={18}/>
        </button>
        <p className="text-[11px] tracking-[0.18em] uppercase text-ink-500">Research · Anonymous</p>
        <div className="w-10"/>
      </div>
      <Radar/>
    </div>
  );
}
